import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CookiesConfigComponent } from '../cookies-config/cookies-config.component';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss'
})
export class CookiesComponent {

  constructor(public dialogRef: MatDialogRef<CookiesComponent>,
              private matDialog: MatDialog) {}

  selectOpt( value: string ) {
    localStorage.setItem( 'policyCookies', value );
    this.dialogRef.close();
  }

  openConfigModal(){
    this.matDialog.open( CookiesConfigComponent, {
      minWidth: '300px',
      maxWidth: '100vw',
    } );
  }
}
